<template>
  <div class="imagelayout" style="min-height:300px;">
    <div v-if="loading">
      <div class="lds-heart">
        <div></div>
      </div>
      <p class="loading"><h2>loading please wait...</h2>
    </div>
    <div class="imagelayoutstyle">
      <div class="imagelayoutsingle" v-for="image in pageOfItems" v-bind:key="image.id" >
        <a :href="image.imageURL" target="_blank">
          <img class="images" :src="image.imageURL" />
        </a>
      </div>
    </div>
    <div class="card-footer">
      <jw-pagination :items="images" @changePage="onChangePage"></jw-pagination>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      pageOfItems: []
    }
  },

  props: {
    images: {
      type: Array,
      default: () => null
    },
    loading: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    onChangePage (pageOfItems) {
      this.pageOfItems = pageOfItems
      window.scrollTo(0, 150)
    }
  }
}

</script>

<style lang="scss">
@import "../assets/common.scss";

.loading {
  margin-top: -20px;
}

.imagelayoutstyle {
  width: auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  @media (max-width: 760px) {
    margin-top:-50px;
    flex-direction: column;
    width: 100%;
  }
}

.imagelayoutsingle {
  height: 300px;
  @media (max-width: 760px) {
    height: auto;
    width: 100%;
  }
}

.images {
  box-sizing: border-box;
  border: .5px solid $content-colour;
  max-height: 100%;
  max-width: 100%;
}

.lds-heart {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  transform: rotate(45deg);
  transform-origin: 40px 40px;
}
.lds-heart div {
  top: 32px;
  left: 32px;
  position: absolute;
  width: 32px;
  height: 32px;
  background: $active-colour;
  animation: lds-heart 1.2s infinite cubic-bezier(0.215, 0.61, 0.355, 1);
}
.lds-heart div:after,
.lds-heart div:before {
  content: " ";
  position: absolute;
  display: block;
  width: 32px;
  height: 32px;
  background: $active-colour;
}
.lds-heart div:before {
  left: -24px;
  border-radius: 50% 0 0 50%;
}
.lds-heart div:after {
  top: -24px;
  border-radius: 50% 50% 0 0;
}
@keyframes lds-heart {
  0% {
    transform: scale(0.95);
  }
  5% {
    transform: scale(1.1);
  }
  39% {
    transform: scale(0.85);
  }
  45% {
    transform: scale(1);
  }
  60% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(0.9);
  }
}

.card-footer {
  margin-top: 20px;
  .page-link {
    position: relative;
    display: block;
    padding: .5rem .75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: $active-colour;
    background-color: #fff;
    border: 1px solid #dee2e6;
  }

  a {
    color: $active-colour;
    text-decoration: none;
    background-color: transparent;
  }

  .page-item.disabled .page-link {
    color: #6c757d;
    pointer-events: none;
    cursor: auto;
    background-color: #fff;
    border-color: #dee2e6;
  }

  .page-item.active .page-link {
    z-index: 1;
    color: #fff;
    background-color: $active-colour;
    border-color: $active-colour;
  }
}

</style>
